export const MEDIALINK_SORTING_OPTION = {
  CATEGORY: 'category',
  LESSON: 'lesson_order',
} as const;

const medialinkSortingValues = Object.values(MEDIALINK_SORTING_OPTION);

export type MedialinkSorting = typeof medialinkSortingValues[number];

export function isOfMedialinkSorting(
  value: string,
  handleError: (error: unknown) => void,
): asserts value is MedialinkSorting {
  if (Object.values(MEDIALINK_SORTING_OPTION).includes(value as MedialinkSorting)) return;

  handleError(
    new Error(
      `Invalid sorting option is provided. Use one of the following values: ${Object.values(
        MEDIALINK_SORTING_OPTION,
      ).join(', ')}`,
    ),
  );
}
